import {
  CREATE_USER_SUCCESS,
  FETCH_PAYMENT_METHODS_SUCCESS,
  FETCH_USER_SUCCESS,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER_SUCCESS,
  REMOVE_CREDIT_CARD_SUCCESS,
  UPDATE_USER_SUCCESS,
} from 'constants/user';
import type { PaymentMethod } from 'models/paymentMethod';
import type { User } from 'models/user';

type UserAction =
  | {
      type:
        | typeof CREATE_USER_SUCCESS
        | typeof FETCH_PAYMENT_METHODS_SUCCESS
        | typeof FETCH_USER_SUCCESS
        | typeof UPDATE_USER_SUCCESS;
      payload: User;
    }
  | {
      type: typeof FETCH_PAYMENT_METHODS_SUCCESS;
      payload: PaymentMethod[];
    }
  | {
      type: typeof REMOVE_CREDIT_CARD_SUCCESS;
      payload: string;
    }
  | {
      type: typeof LOGIN_USER_SUCCESS;
      payload: { authProvider?: string };
    }
  | {
      type: typeof LOGOUT_USER_SUCCESS;
    };

const user = (state: User | Record<string, never> = {}, action: UserAction) => {
  switch (action.type) {
    case LOGIN_USER_SUCCESS:
      return { ...state, authProvider: action.payload.authProvider };
    case CREATE_USER_SUCCESS:
    case FETCH_USER_SUCCESS:
    case UPDATE_USER_SUCCESS:
      return { ...state, ...action.payload };
    case LOGOUT_USER_SUCCESS:
      return {};
    case FETCH_PAYMENT_METHODS_SUCCESS: {
      return {
        ...state,
        paymentMethods: action.payload,
      };
    }
    case REMOVE_CREDIT_CARD_SUCCESS: {
      return {
        ...state,
        paymentMethods: state.paymentMethods?.filter(
          paymentMethod => paymentMethod.token !== action.payload,
        ),
      };
    }
    default:
      return state;
  }
};

export { user };
